import { Component, OnInit, Inject } from '@angular/core';
import { vendorsDB } from '../../../shared/tables/vendor-list';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-vendors',
  templateUrl: './list-vendors.component.html',
  styleUrls: ['./list-vendors.component.scss']
})
export class ListVendorsComponent implements OnInit {
  public vendors = [];

  constructor(private api: ApiService, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) {
    // this.vendors = vendorsDB.data;
  }

  public settings = {
    actions: {
      position: 'right',
      add: false
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      name: {
        title: 'College Name',
        type: 'html',
      },
      email: {
        title: 'Email'
      },
    },
  };

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/colleges').subscribe(
        data => {
          this.vendors = data.data;
          // console.log(this.studymodes);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  updateRecord(event) {
    // console.log(event.newData);
    var data = {"name" : event.newData.name,
                "email" : event.newData.email,
                "_id" : event.newData._id,
                };
        // console.log(data);     
        this.http.put<any>(this.api_endpoint+'/colleges/', data).subscribe(
        res => {
          // console.log(res);
          event.confirm.resolve(event.newData);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }

}
